import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { SimplePopup } from '@calendly/ui/components/popup'
import { getTimezoneName } from '@calendly/timezone-tools'

import { acceptTimezonePopup, dismissTimezonePopup } from 'actions/timezone'
import { detectedTimezoneSelector, timezoneFromQuerySelector } from 'selectors'
import { useI18n } from 'locales'

// i18n-tasks-use t('booking.switch_to_local_timezone_alert.#{step}.title')
// i18n-tasks-use t('booking.switch_to_local_timezone_alert.#{step}.message')
const TimezonePopup = ({ step, timezoneFromQuery = null, detectedTimezone, accept, dismiss }) => {
  const { i18n } = useI18n()
  return (
    <SimplePopup
      isOpen
      onClose={dismiss}
      onConfirm={accept}
      cancelLabel={i18n.t('booking.action.no')}
      confirmLabel={i18n.t('booking.action.yes')}
      title={
        i18n.t(`booking.switch_to_local_timezone_alert.${step}.title`,
          { local_timezone_name: getTimezoneName(detectedTimezone) }
        )
      }
    >
      <div data-popup>
        {
          i18n.t(`booking.switch_to_local_timezone_alert.${step}.message`,
            { current_timezone_name: getTimezoneName(timezoneFromQuery) }
          )
        }
      </div>
    </SimplePopup>
  )
}

const mapStateToProps = (state) => ({
  timezoneFromQuery: timezoneFromQuerySelector(state),
  detectedTimezone: detectedTimezoneSelector(state)
})

const mapDispatchToProps = {
  accept: acceptTimezonePopup,
  dismiss: dismissTimezonePopup
}

TimezonePopup.propTypes = {
  step: PropTypes.string.isRequired,
  timezoneFromQuery: PropTypes.string,
  detectedTimezone: PropTypes.string.isRequired,
  accept: PropTypes.func.isRequired,
  dismiss: PropTypes.func.isRequired
}

export default connect(mapStateToProps, mapDispatchToProps)(TimezonePopup)
